module.exports = "/_next/static/images/UseSegment@2x-f7b254f3155b77e32a8b3bf7aa32f516.webp";